/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateVehicleRequest
 */
export interface UpdateVehicleRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    registrationPlate?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    jurisdiction?: UpdateVehicleRequestJurisdictionEnum;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    friendlyName?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    make?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    model?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateVehicleRequest
     */
    year?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    colour?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    vehicleType?: UpdateVehicleRequestVehicleTypeEnum;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    vin?: string;
    /**
     *
     * @type {number}
     * @memberof UpdateVehicleRequest
     */
    batteryCapacityKwh?: number;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    macAddress?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof UpdateVehicleRequest
     */
    connectorTypes?: Array<UpdateVehicleRequestConnectorTypesEnum>;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    notes?: string;
    /**
     *
     * @type {string}
     * @memberof UpdateVehicleRequest
     */
    status?: UpdateVehicleRequestStatusEnum;
}

/**
 * @export
 */
export const UpdateVehicleRequestJurisdictionEnum = {
    Unknown: "Unknown",
    Act: "ACT",
    Nsw: "NSW",
    Nt: "NT",
    Qld: "QLD",
    Sa: "SA",
    Tas: "TAS",
    Vic: "VIC",
    Wa: "WA",
    National: "National",
} as const;
export type UpdateVehicleRequestJurisdictionEnum =
    (typeof UpdateVehicleRequestJurisdictionEnum)[keyof typeof UpdateVehicleRequestJurisdictionEnum];

/**
 * @export
 */
export const UpdateVehicleRequestVehicleTypeEnum = {
    Unknown: "Unknown",
    Bev: "BEV",
    Phev: "PHEV",
    Fcev: "FCEV",
} as const;
export type UpdateVehicleRequestVehicleTypeEnum =
    (typeof UpdateVehicleRequestVehicleTypeEnum)[keyof typeof UpdateVehicleRequestVehicleTypeEnum];

/**
 * @export
 */
export const UpdateVehicleRequestConnectorTypesEnum = {
    Unknown: "Unknown",
    ChAdeMo: "CHAdeMO",
    Ccs: "CCS",
    Ccs2: "CCS2",
    Type1: "Type1",
    Type2: "Type2",
    Mcs: "MCS",
    Pantograph: "Pantograph",
    Domestic: "Domestic",
} as const;
export type UpdateVehicleRequestConnectorTypesEnum =
    (typeof UpdateVehicleRequestConnectorTypesEnum)[keyof typeof UpdateVehicleRequestConnectorTypesEnum];

/**
 * @export
 */
export const UpdateVehicleRequestStatusEnum = {
    Inactive: "Inactive",
    Active: "Active",
    Archived: "Archived",
} as const;
export type UpdateVehicleRequestStatusEnum =
    (typeof UpdateVehicleRequestStatusEnum)[keyof typeof UpdateVehicleRequestStatusEnum];

/**
 * Check if a given object implements the UpdateVehicleRequest interface.
 */
export function instanceOfUpdateVehicleRequest(
    value: object,
): value is UpdateVehicleRequest {
    return true;
}

export function UpdateVehicleRequestFromJSON(json: any): UpdateVehicleRequest {
    return UpdateVehicleRequestFromJSONTyped(json, false);
}

export function UpdateVehicleRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateVehicleRequest {
    if (json == null) {
        return json;
    }
    return {
        registrationPlate:
            json["registrationPlate"] == null
                ? undefined
                : json["registrationPlate"],
        jurisdiction:
            json["jurisdiction"] == null ? undefined : json["jurisdiction"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        make: json["make"] == null ? undefined : json["make"],
        model: json["model"] == null ? undefined : json["model"],
        year: json["year"] == null ? undefined : json["year"],
        colour: json["colour"] == null ? undefined : json["colour"],
        vehicleType:
            json["vehicleType"] == null ? undefined : json["vehicleType"],
        vin: json["vin"] == null ? undefined : json["vin"],
        batteryCapacityKwh:
            json["batteryCapacityKwh"] == null
                ? undefined
                : json["batteryCapacityKwh"],
        macAddress: json["macAddress"] == null ? undefined : json["macAddress"],
        connectorTypes:
            json["connectorTypes"] == null ? undefined : json["connectorTypes"],
        notes: json["notes"] == null ? undefined : json["notes"],
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function UpdateVehicleRequestToJSON(
    value?: UpdateVehicleRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        registrationPlate: value["registrationPlate"],
        jurisdiction: value["jurisdiction"],
        friendlyName: value["friendlyName"],
        make: value["make"],
        model: value["model"],
        year: value["year"],
        colour: value["colour"],
        vehicleType: value["vehicleType"],
        vin: value["vin"],
        batteryCapacityKwh: value["batteryCapacityKwh"],
        macAddress: value["macAddress"],
        connectorTypes: value["connectorTypes"],
        notes: value["notes"],
        status: value["status"],
    };
}
